import { Metadata, resolveDateRange } from '@dx-ui/dx-common';
import useSetupUsage, {
  SetupUsage,
} from '@dx-ui/dx-common/src/utils/useSetupUsage';
import {
  createColumnsContract,
  createColumnsDeliveryLocation,
  createColumnsOrder,
  createColumnsProcessDetails,
  createColumnsTotals,
  createCommonColumns,
  createCommonFilters,
  createContractFilters,
  createDeliveryLocationFilters,
  createOrderFilters,
  createProcessDetailsFilters,
  createSpecificColumnsOrder,
  createSpecificOrderFilters,
  createTotalsFilters,
} from '../../aspects';
import { CommonList, DisplayContextualButtons } from '../../shared';

/**
 * Declare the additional columns to display (aspects)
 */
const columns: any[] = [
  ...createCommonColumns(),
  ...createColumnsDeliveryLocation(),
  ...createColumnsContract(),
  ...createColumnsTotals(),
  ...createColumnsProcessDetails(),
  ...createColumnsOrder(),
  ...createSpecificColumnsOrder(),
];

/**
 * Specific filters for orders
 */
const additionalFilters: any[] = [
  ...createCommonFilters(),
  ...createDeliveryLocationFilters(),
  ...createContractFilters(),
  ...createTotalsFilters(),
  ...createProcessDetailsFilters(),
  ...createOrderFilters(),
  ...createSpecificOrderFilters(),
];

/**
 * Order list component
 */
const OrderList = (props) => {
  const setupUsage: SetupUsage | undefined = useSetupUsage();
  const isDemoSetup: boolean = setupUsage === SetupUsage.DEMO;
  return (
    <CommonList
      title='dxMessages.orders.title'
      {...props}
      columns={columns}
      additionalFilters={additionalFilters}
      contextualToolbar={<DisplayContextualButtons />}
      filterDefaultValues={
        isDemoSetup
          ? {}
          : {
              [Metadata.created]: resolveDateRange({
                predefinedRange: 'last-7-days',
              }),
            }
      }
    />
  );
};

export default OrderList;
